import React, { useState, useEffect, useCallback } from "react";
import Commonheader from "./Commonheader";
import useAxios from "../hooks/useAxios";
import { QueryBuilder, formatQuery, RuleGroupType } from "react-querybuilder";

function ServiceClone(props) {
  const [loading, sendRequest] = useAxios();
  // const [searchKey, setsearchKey] = useState([
  //   { searchKey: "", searchValue: "" },
  // ]);
  // const [tempsearchKey, settempsearchKey] = useState([
  //   { searchKey: "", operator: "", searchValue: "" },
  // ]);
  // const [get_bucketfield, setget_bucketfield] = useState(false);

  const [isErrOpen, setisErrOpen] = useState(false);
  const [api_error_message, setapi_error_message] = useState();
  const [Operators, setOperators] = useState([
    { mops: "$gt", op: ">" },
    { mops: "$lt", op: "<" },
    { mops: "$gte", op: ">=" },
    { mops: "$lte", op: "<=" },
    { mops: "$in", op: "in" },
    { mops: "$eq", op: "==" }
  ]);

  const [showinputparam, setshowinputparam] = useState(false);
  // const [api_token, setapi_token] = useState("test-token-for-collection-app");
  const [sel_config_data_final, setsel_config_data_final] = useState();
  const [filetype, setfiletype] = useState(["csv", "excel", "pdf"]);
  const [outputtype, setoutputtype] = useState(["nothing", "upload_cloud", "email"]);
  const [object_id, setobject_id] = useState("");
  const [apiparamdata, setapiparamdata] = useState({ "flag": "D", "key": "", "value": "", "con_datatype": "" });
  const [apiurlparamdata, setapiurlparamdata] = useState({ "flag": "D", "value": "" });
  const [api_data, setapi_data] = useState({ "api_url": "", "body_type": "JSON", "enabled": 0, "method": "POST", "data": [], "url_param_data": [] });
  const [topicconfig, settopicconfig] = useState({ "topic": "", "payload_path": [] });
  const [status, setstatus] = useState([]);
  const [seldata, setseldata] = useState({});
  // const [apidatafinal,setapidatafinal] = useState([]);
  const [indexColumnValue, setindexColumnValue] = useState("");


  useEffect(() => {

    const { sel_config_data } = (props.location && props.location.state) || {};
    var temp = sel_config_data;

    temp.queries.map((item) => {
      if (!("input_param" in item.output_config)) {
        item.output_config["input_param"] = {};
      }
      if (!("topic_config" in item)) {
        item["topic_config"] = { "topic": "", "payload_path": [] };
      }
      if (!("api" in item)) {
        item["api"] = [];
      }

      if (!("APIOnly" in item)) {
        item["APIOnly"] = 0;
      }

      if ('blockdata' in item) {
        item.blockdata = [];        
      }
    });
    setsel_config_data_final(temp);
    setobject_id(temp._id.$oid);
    console.log("sel_config_data_final", sel_config_data_final);
    fetchStatusMaster();

  }, [sel_config_data_final]);



  const [, updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);


  const fetchConfigData = () => {
    let api_token = localStorage.getItem("api_token");
    sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/mongo/get/configuration_master/service_configuration/${object_id}`,
        method: "GET",
        headers: {
          "api-token": api_token,
        },
      },
      (response) => {
        props.location.state.sel_config_data = response;
        setsel_config_data_final(response);
      },
      (error) => {
        console.error("API request failed:", error);
      }
    );
  };

  const fetchStatusMaster = () => {
    let api_token = localStorage.getItem("api_token");

    sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/get/dropdown/item/master/data/3`,
        method: "GET",
        headers: {
          "api-token": api_token,
        },
      },
      (response) => {
        // setstatus(response);
        var tmp = [];

        (response).map((item) => {
          tmp.push({ "item_value": item.item_value, "item_name": item.item_name });
        });

        setstatus(tmp);
      },
      (error) => {
        console.error("API request failed:", error);
      }
    );
  };

  const addParamData = (e) => {
    var query_id = e.target.id.split("|")[1];
    var key_name = e.target.id.split("|")[0];
    var temp_config_data = sel_config_data_final;

    console.log(e.target.id);

    if (key_name == "add_param_btn") {
      var second_query_id = e.target.id.split("|")[2];
      temp_config_data.queries[query_id].api[second_query_id].data.push(apiparamdata);
    } else if (key_name == "add_topic_param_btn") {
      temp_config_data.queries[query_id].topic_config['payload_path'].push(apiparamdata);
    } else if (key_name == "remove_param_btn") {
      var second_query_id = e.target.id.split("|")[2];
      temp_config_data.queries[query_id].api[second_query_id].data.splice(e.target.id.split("|")[3], 1);
    } else if (key_name == "remove_topic_param_btn") {
      temp_config_data.queries[query_id].topic_config['payload_path'].splice(e.target.id.split("|")[2], 1);
    } else if (key_name == "add_url_param") {
      var second_query_id = e.target.id.split("|")[2];
      temp_config_data.queries[query_id].api[second_query_id].url_param_data.push(apiurlparamdata);
    } else if (key_name == "remove_url_param") {
      var second_query_id = e.target.id.split("|")[2];
      temp_config_data.queries[query_id].api[second_query_id].url_param_data.splice(e.target.id.split("|")[3], 1);
    }
    setsel_config_data_final(temp_config_data);
    // console.log(sel_config_data_final);
    forceUpdate();

  };


  const handleUpdateData = (e) => {

    var query_id = e.target.id.split("|")[1];
    var key_name = e.target.id.split("|")[0];
    var other_query_id = "";
    if (e.target.id.split("|").length > 1) {
      other_query_id = e.target.id.split("|")[2];
    }

    // console.log(key_name);
    // console.log(e.target.id);
    // console.log(e.target.value);
    // return;


    var temp_config_data = sel_config_data_final;

    if (key_name == "source_operator") {
      let opr = Operators.filter((operator) => operator.mops == e.target.value);
      var temp = {}
      temp[opr[0].mops] = parseInt(document.getElementById("source_status|" + query_id).value);
      temp_config_data.queries[query_id].query.find.status = temp;
    } else if (key_name == "source_status") {
      var temp = {}
      temp[document.getElementById("source_operator|" + query_id).value] = parseInt(e.target.value);
      temp_config_data.queries[query_id].query.find.status = temp;
    } else if (key_name == "dest_status") {
      temp_config_data.queries[query_id].output_config.dest_status = parseInt(e.target.value);
    } else if (key_name == "file_type") {
      temp_config_data.queries[query_id].output_config.file_type = e.target.value;
    } else if (key_name == "get_data") {
      temp_config_data.queries[query_id].output_config.get_data.source_value_key_name = e.target.value;
    } else if (key_name == "type") {
      temp_config_data.queries[query_id].output_config.type = e.target.value;
      document.getElementById('emailcollapseOne|' + query_id).classList.remove('collapse');

      if (e.target.value == "email") {
        temp_config_data.queries[query_id].output_config.input_param = { "attachment_name": "", "body": "", "cc": "", "subject": "", "to": "" };
      } else if (e.target.value == "upload_cloud") {
        temp_config_data.queries[query_id].output_config.input_param = { "file_name": "", "folder_name": "", "gcp_path": "" };
        document.getElementById("email_btn|" + query_id).classList.remove("collapsed");
      } else {
        temp_config_data.queries[query_id].output_config.input_param = {};
        document.getElementById('emailcollapseOne|' + query_id).classList.add('collapse');
      }
    } else if (key_name == "sleep_time") {
      temp_config_data.queries[query_id].sleep_timer = parseInt(e.target.value);
    } else if (temp_config_data.queries[query_id].output_config.type == "email") {
      // console.log(e.target.id);
      temp_config_data.queries[query_id].output_config.input_param[key_name] = e.target.value;
    }

    if (key_name === "api_only") {

      temp_config_data.queries[query_id].APIOnly = parseInt(e.target.value);
    }


    if (key_name === "api_url") {
      temp_config_data.queries[query_id].api[other_query_id].api_url = e.target.value;
    } else if (key_name === "method") {
      temp_config_data.queries[query_id].api[other_query_id].method = e.target.value;
    } else if (key_name === "body_type") {
      temp_config_data.queries[query_id].api[other_query_id].body_type = e.target.value;
    } else if (key_name == "api_enabled") {
      temp_config_data.queries[query_id].api[other_query_id].enabled = parseInt(e.target.value);
    } else if (key_name == "api_flag") {
      var third_query_id = e.target.id.split("|")[3];
      temp_config_data.queries[query_id].api[other_query_id].data[third_query_id].flag = e.target.value;
    } else if (key_name == "api_key") {
      var third_query_id = e.target.id.split("|")[3];
      temp_config_data.queries[query_id].api[other_query_id].data[third_query_id].key = e.target.value;
    } else if (key_name == "api_value") {
      var third_query_id = e.target.id.split("|")[3];
      temp_config_data.queries[query_id].api[other_query_id].data[third_query_id].value = e.target.value;
    } else if (key_name == "convert_dt") {
      var third_query_id = e.target.id.split("|")[3];
      temp_config_data.queries[query_id].api[other_query_id].data[third_query_id].con_datatype = e.target.value;
    } else if (key_name == "api_url_flag") {
      var third_query_id = e.target.id.split("|")[3];
      temp_config_data.queries[query_id].api[other_query_id].url_param_data[third_query_id].flag = e.target.value;
    } else if (key_name == "api_url_value") {
      var third_query_id = e.target.id.split("|")[3];
      temp_config_data.queries[query_id].api[other_query_id].url_param_data[third_query_id].value = e.target.value;
    }


    if (key_name == "topic") {
      temp_config_data.queries[query_id].topic_config["topic"] = e.target.value;
    } else if (key_name == "topic_flag") {
      temp_config_data.queries[query_id].topic_config.payload_path[other_query_id].flag = e.target.value;
    } else if (key_name == "topic_key") {
      temp_config_data.queries[query_id].topic_config.payload_path[other_query_id].key = e.target.value;
    } else if (key_name == "topic_value") {
      temp_config_data.queries[query_id].topic_config.payload_path[other_query_id].value = e.target.value;
    } else if (key_name == "topic_cdatatype") {
      temp_config_data.queries[query_id].topic_config.payload_path[other_query_id].flag = e.target.value;
    }
    // console.log(temp_config_data.queries[query_id].topic_config);

    console.log(temp_config_data);
    setsel_config_data_final(temp_config_data);


    // console.log(sel_config_data_final);

    forceUpdate();
    // this.forceUpdate();

    // console.log(sel_config_data.queries[query_id]);


  };

  const addAPIDataRow = (e) => {


    var query_id = e.target.id.split("|")[1];
    var key_name = e.target.id.split("|")[0];

    // delete_api_btn
    if (key_name == "add_api_btn") {
      sel_config_data_final.queries[query_id].api.push(api_data);
    } else {
      sel_config_data_final.queries[query_id].api.splice(e.target.id.split("|")[2], 1);
    }
    // console.log(sel_config_data_final);
    forceUpdate();
  };

  const addTopicConfig = (e) => {
    var query_id = e.target.id.split("|")[1];
    var temp = sel_config_data_final.queries[query_id].topic_config;
    console.log(temp);
  };



  const updateData = (e) => {

    var query_id = e.target.id.split("|")[1];
    var key_name = e.target.id.split("|")[0];
    var flag = 0;

    if (key_name == "enable") {

      if (e.target.innerText == "Disable") {
        sel_config_data_final.queries[query_id].enabled = 0;
      } else {
        sel_config_data_final.queries[query_id].enabled = 1;
      }
    } else if (key_name == "deleteBtn") {
      if (window.confirm("Do You Really Want to Delete?") == true) {
        sel_config_data_final.queries.splice(query_id, 1)
        flag = 0;
      } else {
        flag = 1;
      }
    } else {
      var errMSG = "";
      if (sel_config_data_final.queries[query_id].output_config.type == "email") {

        for (var key in sel_config_data_final.queries[query_id].output_config.input_param) {
          if (sel_config_data_final.queries[query_id].output_config.input_param[key] == "") {
            flag = 1;
            errMSG = "Please Enter All Details Required for Email";
          }
        }
      }

    }

    delete sel_config_data_final["_id"];

    if (flag == 0) {
      let api_token = localStorage.getItem("api_token");
      sendRequest(
        {
          url: `${process.env.REACT_APP_BASE_URL}/mongo/updateone/configuration_master/service_configuration/${object_id}`,
          method: "POST",
          data: sel_config_data_final,
          headers: {
            "api-token": api_token,
          },
        },
        (response) => {
          console.log(response);

          if (response[0].matched > 0 && response[0].updated > 0) {
            alert("Updated Successfully!");
            fetchConfigData();
          }

          // console.log(response.length);
          // if (response.length > 0) {
          // setconfig_data(response);
          // }
          // console.log(config_data);
        },
        (error) => {
          console.error("API request failed:", error);
        }
      );
    }
    // else {

    // }
  };

  const handleAddStage = () => {
    let temp = { "query_name": "", "sleep_time": "", "enabled": 0 };
    sel_config_data_final.queries.push(temp);

    console.log(sel_config_data_final);
    forceUpdate();
  };

  const setConfigDetails = (event) => {

    setseldata({});

    // console.log(event.target.value);

    // console.log();
    if (event.target.value != "") {
      let td = sel_config_data_final.queries[event.target.value];
      td["temp_index"] = parseInt(event.target.value);
      setseldata(td);
      // setseldata(sel_config_data_final.queries[]);
      // console.log(seldata);
    } else {
      setseldata({});
    }
  };

  // console.log(sel_config_data_final);

  console.log(seldata);



  return (
    <div className="col-lg-12">
      <Commonheader pagetitle={"Edit Service Details"} props={props} />
      {loading && (
        <div className="load-4">
          <div className="ring-1"></div>
        </div>
      )}
      <div
        className={
          isErrOpen
            ? "modal fade show d-block mymodal"
            : "modal fade bd-example-modal-sm"
        }
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
        id="confirm-box"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content cdb-confirm-box col-sm-12">
            <button
              type="button"
              className="close text-right"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                setisErrOpen(false);
                window.location.reload();
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <p className="popuperrtext">{api_error_message}</p>
          </div>
        </div>
      </div>

      <div className="d-flex col-md-10 col-xs-10 justify-content-md-center">
        <div className="col-md-2 col-xs-1 col-md-offset-3">
          <label>Select Configuration</label>
        </div>
        <div className="col-md-6 col-xs-6">
          <select className="form-control" onChange={setConfigDetails}>
            <option value="">Select Query</option>
            {
              sel_config_data_final &&
              sel_config_data_final.queries.map((item, index) => (
                <option value={index}>{item.query_name}</option>
              ))
            }

          </select>

        </div>
      </div>
      <br></br>


      {
        Object.keys(seldata).length > 0 ? (
          <>
            <div class="row" style={{ border: "1px solid rgba(0,0,0,.125)", borderRadius: "4px", margin: "0 0 5px 0", padding: "15px 0" }}>
              <div class="col-3">
                <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                  <button class="nav-link active" id="v-pills-api-tab" data-toggle="pill" data-target="#v-pills-api" type="button" role="tab" aria-controls="v-pills-api" aria-selected="true" style={{ borderRadius: "0px" }}>API</button>
                  <button class="nav-link" id="v-pills-src-dest-tab" data-toggle="pill" data-target="#v-pills-src-dest" type="button" role="tab" aria-controls="v-pills-src-dest" aria-selected="false" style={{ borderRadius: "0px" }}>Source & Destination </button>
                  <button class="nav-link" id="v-pills-topic-tab" data-toggle="pill" data-target="#v-pills-topic" type="button" role="tab" aria-controls="v-pills-topic" aria-selected="false" style={{ borderRadius: "0px" }}>Topic Config</button>
                  <button class="nav-link" id="v-pills-block-data-tab" data-toggle="pill" data-target="#v-pills-block-data" type="button" role="tab" aria-controls="v-pills-block-data" aria-selected="false" style={{ borderRadius: "0px" }}>Block Data</button>
                  <button class="nav-link" id="v-pills-settings-tab" data-toggle="pill" data-target="#v-pills-settings" type="button" role="tab" aria-controls="v-pills-settings" aria-selected="false" style={{ borderRadius: "0px" }}>Output Config</button>
                </div>
              </div>
              <div class="col-9">
                <div class="tab-content" id="v-pills-tabContent">
                  <div class="tab-pane fade show active" id="v-pills-api" role="tabpanel" aria-labelledby="v-pills-api-tab">
                    {
                      ("api" in seldata) ?
                        <>
                          <button class="btn btn-sm btn-primary" onClick={addAPIDataRow} id={"add_api_btn|" + seldata["temp_index"]}>Add APIs</button><br /><br />

                          <table className="table col-md-12">
                            <thead class="thead-light">

                              <tr>
                                <th>Seq No.</th>
                                <th className="col-md-2">URL</th>
                                <th>Method</th>
                                <th>Body Type</th>
                                <th>Status</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {
                                (seldata.api.length > 0) ?
                                  (seldata.api.map((api_item, api_index) => (<>
                                    <tr>
                                      <td rowSpan={("url_param_data" in api_item) ? 3 : 2}>{api_index + 1}</td>

                                      <td className="col-md-4">{<textarea rows={2} cols={70} placeholder='Enter URL' defaultValue={api_item.api_url} id={"api_url|" + seldata["temp_index"] + "|" + api_index} onChange={handleUpdateData}></textarea>}</td>

                                      <td>{<select id={"method|" + seldata["temp_index"] + "|" + api_index} defaultValue={api_item.method} onChange={handleUpdateData} onClick={handleUpdateData}><option value='POST'>POST</option><option value='GET'>GET</option><option value='PUT'>PUT</option><option value='DELETE'>DELETE</option></select>}</td>

                                      <td>{<select defaultValue={api_item.body_type} id={"body_type|" + seldata["temp_index"] + "|" + api_index} onChange={handleUpdateData} > <option value='JSON'>JSON</option><option value='formdata'>Formdata</option></select>}</td>

                                      <td>
                                        {<select defaultValue={api_item.enabled} id={"api_enabled|" + seldata["temp_index"] + "|" + api_index} onChange={handleUpdateData}><option value={1}>Enable</option><option value={0}>Disable</option></select>}
                                      </td>

                                      <td><button className="btn btn-danger" onClick={addAPIDataRow} id={"delete_api_btn|" + seldata["temp_index"] + "|" + api_index}>Delete</button></td>
                                    </tr>
                                    <tr>
                                      <td colSpan={6}>
                                        <button className="btn btn-sm" id={"add_param_btn|" + seldata["temp_index"] + "|" + api_index} onClick={addParamData}>Add Params</button>
                                        {
                                          (api_item.data.map((api_item_data, api_item_index) => (
                                            <>

                                              <div className="form-row">
                                                <div class="form-group col-md-2">
                                                  <label for="inputPassword4">Flag</label>
                                                  <select class="form-control" defaultValue={api_item_data.flag} id={"api_flag|" + seldata["temp_index"] + "|" + api_index + "|" + api_item_index} onChange={handleUpdateData} onClick={handleUpdateData}>
                                                    <option value="D">Dynamic</option>
                                                    <option value="S">Static</option>
                                                  </select>
                                                  {/* <input type="text" class="form-control" defaultValue={api_item_data.flag} /> */}
                                                </div>
                                                <div class="form-group col-md-3">
                                                  <label for="inputPassword4">Key</label>
                                                  <input type="text" class="form-control" defaultValue={api_item_data.key} onChange={handleUpdateData} id={"api_key|" + seldata["temp_index"] + "|" + api_index + "|" + api_item_index} />
                                                </div>
                                                <div class="form-group col-md-3">
                                                  <label for="inputPassword4">Value</label>
                                                  <input type="text" class="form-control" defaultValue={api_item_data.value} onChange={handleUpdateData} id={"api_value|" + seldata["temp_index"] + "|" + api_index + "|" + api_item_index} />
                                                </div>
                                                <div class="form-group col-md-2">
                                                  <label for="inputPassword4">Convert Datatype</label>
                                                  <input type="text" class="form-control" defaultValue={api_item_data.con_datatype} onChange={handleUpdateData} id={"convert_dt|" + seldata["temp_index"] + "|" + api_index + "|" + api_item_index} />
                                                </div>

                                                <div class="form-group col-md-2" style={{ margin: "auto", paddingTop: '8px' }}>
                                                  <button className="btn btn-sm btn-danger" id={"remove_param_btn|" + seldata["temp_index"] + "|" + api_index + "|" + api_item_index} onClick={addParamData}>Remove</button>
                                                </div>
                                              </div>
                                            </>
                                          )))
                                        }

                                      </td>
                                    </tr>
                                    {
                                      ("url_param_data" in api_item) ?
                                        <tr>
                                          <td colSpan={6}>
                                            <button className="btn btn-sm" id={"add_url_param|" + seldata["temp_index"] + "|" + api_index} onClick={addParamData}>Add URL Params</button>

                                            {
                                              (api_item.url_param_data.map((api_url_item_data, api_url_item_index) => (
                                                <>
                                                  <div className="form-row">
                                                    <div class="form-group col-md-4">
                                                      <label for="inputPassword4">Flag</label>
                                                      <select class="form-control" defaultValue={api_url_item_data.flag} id={"api_url_flag|" + seldata["temp_index"] + "|" + api_index + "|" + api_url_item_index} onChange={handleUpdateData} onClick={handleUpdateData}>
                                                        <option value="D">Dynamic</option>
                                                        <option value="S">Static</option>
                                                      </select>

                                                    </div>
                                                    <div class="form-group col-md-4">
                                                      <label for="inputPassword4">Value</label>
                                                      <input type="text" class="form-control" defaultValue={api_url_item_data.value} onChange={handleUpdateData} id={"api_url_value|" + seldata["temp_index"] + "|" + api_index + "|" + api_url_item_index} />
                                                    </div>

                                                    <div class="form-group col-md-4" style={{ margin: "auto", marginLeft: 0, paddingTop: '8px' }}>
                                                      <button className="btn btn-sm btn-danger" id={"remove_url_param|" + seldata["temp_index"] + "|" + api_index + "|" + api_url_item_index} onClick={addParamData}>Remove</button>
                                                    </div>
                                                  </div>
                                                </>
                                              )
                                              ))}
                                          </td>
                                        </tr>
                                        : ""
                                    }




                                  </>
                                  ))) : ""
                              }


                            </tbody>
                          </table>
                        </>
                        : ""
                    }
                  </div>
                  <div class="tab-pane fade" id="v-pills-src-dest" role="tabpanel" aria-labelledby="v-pills-src-dest-tab">
                    <div className="form-row">
                      <div class="form-group col-md-5">
                        <label for="inputPassword4">Source Status</label>
                        {
                          Object.keys(seldata.query.find.status).map((key, i) => (
                            <div className="form-row"> <div class="form-group col-md-4">
                              <select className="form-control" id={"source_operator" + "|" + seldata["temp_index"]} defaultValue={key} onChange={handleUpdateData}>
                                {
                                  (Operators.map((opr, opr_index) => (
                                    <option value={opr.mops}>{opr.op}</option>
                                  )))
                                }
                              </select>
                            </div>
                              <div class="form-group col-md-8">
                                <select class="form-control" id={"source_status" + "|" + seldata["temp_index"]} onChange={handleUpdateData}>
                                  {
                                    (status.map((item_status) => (
                                      (seldata.query.find.status[key] == item_status.item_value) ? <option value={parseInt(item_status.item_value)} selected>{item_status.item_name}</option> :
                                        <option value={parseInt(item_status.item_value)}>{item_status.item_name}</option>
                                    )))
                                  }
                                </select>
                                {/* <input type="text" class="form-control" defaultValue={item.query.find.status[key]} id={"source_status" + "|" + index} onChange={handleUpdateData} /> */}
                              </div>


                            </div>
                          ))
                        }
                      </div>
                      <div class="form-group col-md-3">
                        <label for="inputPassword4">Dest Status</label>
                        <select class="form-control" id={"dest_status" + "|" + seldata["temp_index"]} onChange={handleUpdateData}>
                          {
                            (status.map((item_status) => (
                              (seldata.output_config.dest_status == item_status.item_value) ? <option value={item_status.item_value} selected>{item_status.item_name}</option> :
                                <option value={item_status.item_value}>{item_status.item_name}</option>
                            )))
                          }
                        </select>
                        {/* <input type="text" class="form-control" defaultValue={item.output_config.dest_status} id={"dest_status" + "|" + index} onChange={handleUpdateData} /> */}
                      </div>
                      <div class="form-group col-md-2">
                        <label for="inputPassword4">Sleep Time</label>
                        <input type="text" class="form-control" defaultValue={seldata.sleep_timer} id={"sleep_time" + "|" + seldata["temp_index"]} onChange={handleUpdateData} />
                      </div>
                      <div class="form-group col-md-2">
                        <label for="inputPassword4">API Only</label>
                        <select class="form-control" id={"api_only" + "|" + seldata["temp_index"]} onChange={handleUpdateData}>
                          <option value={0} selected={seldata["APIOnly"] == 0 ? 1 : 0}>Job and API</option>
                          <option value={1} selected={seldata["APIOnly"] == 1 ? 1 : 0}>API Only</option>
                        </select>
                      </div>

                    </div>

                  </div>
                  <div class="tab-pane fade" id="v-pills-topic" role="tabpanel" aria-labelledby="v-pills-topic-tab">
                    {
                      ("topic_config" in seldata) ?
                        <table className="table col-md-12">
                          <thead class="thead-light">

                            <tr>
                              <th className="col-md-2">Topic Name</th>
                              <th>Payload Data</th>
                            </tr>
                          </thead>
                          <tbody id={"topic_config_tbody|" + seldata["temp_index"]}>
                            {
                              <tr>
                                <td className="col-md-3"><input type="text" class="form-control" defaultValue={seldata.topic_config.topic == "" ? "" : seldata.topic_config.topic} id={"topic|" + seldata["temp_index"]} onChange={handleUpdateData} /></td>
                                <td>
                                  <button className="btn btn-sm" id={"add_topic_param_btn|" + seldata["temp_index"]} onClick={addParamData}>Add Params</button>

                                  {
                                    ("payload_path" in seldata.topic_config) ?
                                      (seldata.topic_config.payload_path.length > 0) ?
                                        (seldata.topic_config.payload_path.map((topic_payload, topic_index) => (
                                          <div className="form-row">
                                            <div class="form-group col-md-2">
                                              <label for="inputPassword4">Flag</label>
                                              <select class="form-control" defaultValue={topic_payload.flag} id={"topic_flag|" + seldata["temp_index"] + "|" + topic_index} onChange={handleUpdateData} onClick={handleUpdateData}>
                                                <option value="D">Dynamic</option>
                                                <option value="S">Static</option>
                                              </select>

                                            </div>
                                            <div class="form-group col-md-3">
                                              <label for="inputPassword4">Key</label>
                                              {/* <input type="text" class="form-control" defaultValue={topic_payload.key} /> */}
                                              <input type="text" class="form-control" defaultValue={topic_payload.key} onChange={handleUpdateData} id={"topic_key|" + seldata["temp_index"] + "|" + topic_index} />
                                            </div>
                                            <div class="form-group col-md-3">
                                              <label for="inputPassword4">Value</label>
                                              {/* <input type="text" class="form-control" defaultValue={topic_payload.value} /> */}
                                              <input type="text" class="form-control" defaultValue={topic_payload.value} onChange={handleUpdateData} id={"topic_value|" + seldata["temp_index"] + "|" + topic_index} />

                                            </div>
                                            <div class="form-group col-md-3">
                                              <label for="inputPassword4">Datatype</label>
                                              {/* <input type="text" class="form-control" defaultValue={topic_payload.con_datatype} /> */}
                                              <input type="text" class="form-control" defaultValue={topic_payload.con_datatype} onChange={handleUpdateData} id={"topic_cdatatype|" + seldata["temp_index"] + "|" + topic_index} />

                                            </div>

                                            <div class="form-group col-md-1" style={{ margin: "auto", paddingTop: '8px' }}>
                                              <button className="btn btn-sm btn-danger" id={"remove_topic_param_btn|" + seldata["temp_index"] + "|" + topic_index} onClick={addParamData}>Remove</button>
                                            </div>
                                          </div>
                                        )))
                                        : ""
                                      : ""
                                  }
                                </td>
                              </tr>
                            }
                          </tbody>
                        </table>
                        : ""
                    }
                  </div>
                  <div class="tab-pane fade" id="v-pills-block-data" role="tabpanel" aria-labelledby="v-pills-block-data-tab">
                    {
                      ("blockdata" in seldata) ?
                        <table className="table col-md-12">
                          <thead className="thead-light">
                            <tr>
                              <th className="col-md-2">Block Name</th>
                              <th className="col-md-2">Operations</th>
                            </tr>
                          </thead>
                          <tbody id={"blockdata_config_tbody|" + seldata["temp_index"]}>
                            {
                              seldata.blockdata.map((data, topic_index) => {
                                const blockName = Object.keys(data)[0]; // Get the key name
                                const value = data[blockName]; // Get the value associated with the key

                                return (
                                  <tr key={topic_index}>
                                    <td className="col-md-3">
                                      {blockName}
                                    </td>
                                    <td className="col-md-3">
                                      <button className="btn btn-sm btn-info" value="1">Update</button>&nbsp;
                                      <button className="btn btn-sm btn-success" value="0">Save</button>
                                    </td>
                                  </tr>
                                );
                              })
                            }
                          </tbody>
                        </table>

                        : ""
                    }
                  </div>
                  <div class="tab-pane fade" id="v-pills-settings" role="tabpanel" aria-labelledby="v-pills-settings-tab">
                    <div className="form-row">
                      <div class="form-group col-md-12">
                        <div className="form-row">
                          <div class="form-group col-md-6">
                            <label for="inputPassword4">File Type</label>
                            <select class="form-control" id={"file_type|" + seldata["temp_index"]} onChange={handleUpdateData}>
                              <option value={seldata.output_config.file_type === 'csv'}>CSV</option>
                            </select>
                          </div>
                          <div class="form-group col-md-6">
                            <label for="inputPassword4">Index Column Name</label>
                            <input type="text" class="form-control" placeholder="Index Column Name" value={indexColumnValue} id={"index_column_value" + "|" + seldata["temp_index"]} onChange={handleUpdateData} />
                          </div>
                        </div>

                        <div className="form-row">
                          <div class="form-group col-md-6">
                            <label for="inputPassword4">Source Value Key Name</label>
                            <input type="text" class="form-control" placeholder="Source Value Key Name" value={indexColumnValue} id={"Source_value_key_name" + "|" + seldata["temp_index"]} onChange={handleUpdateData} />
                          </div>
                          <div class="form-group col-md-6">
                            <label for="inputPassword4">Index Flag</label>
                            <select class="form-control" id={"index_flag|" + seldata["temp_index"]} onChange={handleUpdateData}>
                              <option value={0}>True</option>
                              <option value={1}>False</option>
                            </select>
                          </div>
                        </div>

                        <div className="form-row">
                          <div class="form-group col-md-6">
                            <label for="inputPassword4">Upload Type</label>
                            <select class="form-control" id={"Upload_type|" + seldata["temp_index"]} onChange={handleUpdateData}>
                              <option value={seldata.output_config.type === 'nothing'}>Nothing</option>
                            </select>
                          </div>
                        </div>

                        <div className="form-row">
                          {Object.keys(seldata.output_config.input_param).map((key) => (
                            <div className="form-group col-md-4" key={key}>
                              <label htmlFor={key}>{key.replace(/_/g, ' ')}</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder={key.replace(/_/g, ' ')}
                                value={seldata.output_config.input_param[key]}
                                id={`${key}|${seldata.temp_index}`}
                                onChange={(e) => handleUpdateData(e, key)}
                              />
                            </div>
                          ))}
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>

            </div>
          </>
        ) : ""
      }



      <div className="form-row">
        <div class="form-group col-md-12">
          <div id="accordion_main_data">
            {
              sel_config_data_final &&

              sel_config_data_final.queries.map((item, index) => (
                <div class="card">
                  <div class="card-header col-md-12" id={item.query_name + index}>
                    <div className="row">
                      <div className="col-md-4">
                        <h5>
                          <button class="btn btn-link collapsed" data-toggle="collapse" data-target={"#" + item.query_name + "|" + index} aria-expanded="true" aria-controls="collapseOne">
                            {item.query_name}
                          </button>

                        </h5>
                      </div>
                      <div className="pull-right col-md-8" style={{margin: "auto"}}>
                        <button style={{width: '200px'}} type="button" class={(item.enabled) ? "btn btn-sm btn-warning" : "btn btn-sm btn-success"} id={"enable" + "|" + index} onClick={updateData}>{(item.enabled) ? "Disable" : "Enable"}</button>&nbsp;
                        <button style={{width: '200px'}} type="button" class="btn btn-sm btn-info" id={"updateBtn|" + index} onClick={updateData}>Update</button>&nbsp;
                        <button style={{width: '200px'}} type="button" class="btn btn-sm btn-danger" id={"deleteBtn|" + index} onClick={updateData}>Delete</button>
                      </div>
                    </div>
                  </div>
                  <div id={item.query_name + "|" + index} class="collapse" aria-labelledby={item.query_name + index} data-parent="#accordion_main_data">
                    <div class="card-body">
                      <div className="form-row">
                          <div class="form-group col-md-6">
                            <label for="inputPassword4">Source Status</label>
                            {
                              Object.keys(item.query.find.status).map((key, i) => (
                                <div className="form-row"> 
                                  <div class="form-group col-md-4">
                                    <select className="form-control" id={"source_operator" + "|" + index} defaultValue={key} onChange={handleUpdateData}>
                                      {
                                        (Operators.map((opr, opr_index) => (
                                          <option value={opr.mops}>{opr.op}</option>
                                        )))
                                      }
                                    </select>
                                  </div>
                                  <div class="form-group col-md-8">
                                    <select class="form-control" id={"source_status" + "|" + index} onChange={handleUpdateData}>
                                      {
                                        (status.map((item_status) => (
                                          (item.query.find.status[key] == item_status.item_value) ? <option value={parseInt(item_status.item_value)} selected>{item_status.item_name}</option> :
                                            <option value={parseInt(item_status.item_value)}>{item_status.item_name}</option>
                                        )))
                                      }
                                    </select>
                                    {/* <input type="text" class="form-control" defaultValue={item.query.find.status[key]} id={"source_status" + "|" + index} onChange={handleUpdateData} /> */}
                                  </div>
                                </div>
                              ))
                            }
                          </div>
                          <div class="form-group col-md-3">
                            <label for="inputPassword4">Dest Status</label>
                            <select class="form-control" id={"dest_status" + "|" + index} onChange={handleUpdateData}>
                              {
                                (status.map((item_status) => (
                                  (item.output_config.dest_status == item_status.item_value) ? <option value={item_status.item_value} selected>{item_status.item_name}</option> :
                                    <option value={item_status.item_value}>{item_status.item_name}</option>
                                )))
                              }
                            </select>
                            {/* <input type="text" class="form-control" defaultValue={item.output_config.dest_status} id={"dest_status" + "|" + index} onChange={handleUpdateData} /> */}
                          </div>
                          <div class="form-group col-md-3">
                            <label for="inputPassword4">Get Data</label>
                            {
                              ("get_data" in item.output_config) ? ("source_value_key_name" in item.output_config.get_data) ? <input type="text" placeholder="Get Data" class="form-control" defaultValue={item.output_config.get_data.source_value_key_name} id={"get_data" + "|" + index} onChange={handleUpdateData} /> : <input type="text" class="form-control" defaultValue={""} id={"get_data" + "|" + index} onChange={handleUpdateData} /> : <input type="text" class="form-control" defaultValue={""} id={"get_data" + "|" + index} onChange={handleUpdateData} />
                            }
                          </div>
                        </div>
                        <div className="form-row">
                          <div class="form-group col-md-3">
                            <label for="inputPassword4">File Type</label>
                            <select className="form-control" id={"file_type" + "|" + index} defaultValue={item.output_config.file_type} onChange={handleUpdateData}>
                              {
                                (filetype.map((opr, opr_index) => (
                                  <option value={opr}>{opr}</option>
                                )))
                              }
                            </select>
                          </div>
                          <div class="form-group col-md-3">
                            <label for="inputPassword4">Output Type</label>
                            <select className="form-control" id={"type" + "|" + index} defaultValue={item.output_config.type} onChange={handleUpdateData}>
                              {
                                (outputtype.map((opr, opr_index) => (
                                  <option value={opr}>{opr}</option>
                                )))
                              }
                            </select>
                          </div>
                          <div class="form-group col-md-3">
                            <label for="inputPassword4">Sleep Time</label>
                            <input type="text" class="form-control" defaultValue={item.sleep_timer} id={"sleep_time" + "|" + index} onChange={handleUpdateData} />
                          </div>
                          <div class="form-group col-md-3">
                            <label for="inputPassword4">API Only</label>
                            <select class="form-control" id={"api_only" + "|" + index} onChange={handleUpdateData} defaultValue={item.APIOnly}>
                              <option value={0}>Job and API</option>
                              <option value={1}>API Only</option>
                            </select>
                          </div>
                      </div>
                      <div className="form-row">


                      </div>
                      <div className="form-row">
                        {
                          // (item.output_config.type == "email") ?
                          // <div className="form-row">
                          <div class="form-group col-md-3">
                            <div id="accordion">
                              <div class="card">
                                <div class="card-header" id={"email" + index}>
                                  <h5 class="mb-0">
                                    <button class="btn btn-link collapsed" data-toggle="collapse" data-target={"#emailcollapseOne|" + index} aria-expanded="true" aria-controls="collapseOne" id={"email_btn|" + index}>
                                      Input params
                                    </button>
                                  </h5>
                                </div>

                                <div id={"emailcollapseOne|" + index} class="collapse" aria-labelledby={"email" + index} data-parent="#accordion">
                                  <div class="card-body">
                                    {
                                      Object.keys(item.output_config.input_param).map((key, i) => (
                                        <div className="form-row" style={{display: 'block'}}> 
                                          <div class="form-group col-md-4" style={{maxWidth: 'fit-content'}}>
                                            <label for="inputPassword4">{key}</label>
                                          </div>
                                          <div class="form-group col-md-8">
                                            <input type="text" class="form-control" defaultValue={item.output_config.input_param[key]} id={key + "|" + index} onChange={handleUpdateData} />
                                          </div>
                                        </div>
                                      ))
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          // </div>
                          // : (showinputparam) ? <>HELLOW</> : ""
                        }
                        {
                          ("topic_config" in item) ?
                            // <div className="form-row">
                            <div class="form-group col-md-9">
                              <div id="accordion">
                                <div class="card">
                                  <div class="card-header col-md-12" id={"headingtopic" + index}>
                                    <h5 class="mb-0">
                                      <button class="btn btn-link collapsed" data-toggle="collapse" data-target={"#topiccollapseOne|" + index} aria-expanded="true" aria-controls="collapseOne">
                                        Topic Config Details
                                      </button>
                                    </h5>
                                  </div>

                                  <div id={"topiccollapseOne|" + index} class="collapse" aria-labelledby={"headingtopic" + index} data-parent="#accordion">
                                    <div class="card-body">

                                      {/* {((item.topic_config.topic == "")) ?
                                    <><button class="btn btn-sm btn-primary" onClick={addTopicConfig} id={"add_topic_config_btn|" + index}>Add Topic Config</button><br /><br /></> : ""
                                  } */}

                                      <table className="table col-md-12">
                                        <thead class="thead-light">

                                          <tr>
                                            <th>Topic Name</th>
                                            <th>Payload Data</th>
                                          </tr>
                                        </thead>
                                        <tbody id={"topic_config_tbody|" + index}>

                                          {
                                            <tr>
                                              <td><input type="text" class="form-control" defaultValue={item.topic_config.topic} id={"topic|" + index} onChange={handleUpdateData} /></td>
                                              <td>
                                                <button className="btn btn-sm" id={"add_topic_param_btn|" + index} onClick={addParamData}>Add Params</button>

                                                {
                                                  ("payload_path" in item.topic_config) ?
                                                    (item.topic_config.payload_path.length > 0) ?
                                                      (item.topic_config.payload_path.map((topic_payload, topic_index) => (
                                                        <div className="form-row">
                                                          <div class="form-group col-md-2">
                                                            <label for="inputPassword4">Flag</label>
                                                            <select class="form-control" defaultValue={topic_payload.flag} id={"topic_flag|" + index + "|" + topic_index} onChange={handleUpdateData} onClick={handleUpdateData}>
                                                              <option value="D">Dynamic</option>
                                                              <option value="S">Static</option>
                                                            </select>

                                                          </div>
                                                          <div class="form-group col-md-3">
                                                            <label for="inputPassword4">Key</label>
                                                            {/* <input type="text" class="form-control" defaultValue={topic_payload.key} /> */}
                                                            <input type="text" class="form-control" defaultValue={topic_payload.key} onChange={handleUpdateData} id={"topic_key|" + index + "|" + topic_index} />
                                                          </div>
                                                          <div class="form-group col-md-3">
                                                            <label for="inputPassword4">Value</label>
                                                            {/* <input type="text" class="form-control" defaultValue={topic_payload.value} /> */}
                                                            <input type="text" class="form-control" defaultValue={topic_payload.value} onChange={handleUpdateData} id={"topic_value|" + index + "|" + topic_index} />

                                                          </div>
                                                          <div class="form-group col-md-2">
                                                            <label for="inputPassword4">Datatype</label>
                                                            {/* <input type="text" class="form-control" defaultValue={topic_payload.con_datatype} /> */}
                                                            <input type="text" class="form-control" defaultValue={topic_payload.con_datatype} onChange={handleUpdateData} id={"topic_cdatatype|" + index + "|" + topic_index} />

                                                          </div>
                                                          <div class="form-group col-md-2" style={{ margin: "auto", paddingTop: '8px' }}>
                                                            <button className="btn btn-sm btn-danger" id={"remove_topic_param_btn|" + index + "|" + topic_index} onClick={addParamData}>Remove</button>
                                                          </div>
                                                        </div>
                                                      )))
                                                      : ""
                                                    : ""
                                                }
                                              </td>
                                            </tr>
                                          }

                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            // </div>
                            : ""
                        }
                      </div>

                      {
                        ("api" in item) ?
                          <div className="form-row">
                            <div class="form-group col-md-12">
                              <div id="accordion">
                                <div class="card">
                                  <div class="card-header col-md-12" id={"headingOne" + index}>
                                    <h5 class="mb-0">
                                      <button class="btn btn-link collapsed" data-toggle="collapse" data-target={"#collapseOne|" + index} aria-expanded="true" aria-controls="collapseOne">
                                        API Details
                                      </button>
                                    </h5>
                                  </div>

                                  <div id={"collapseOne|" + index} class="collapse" aria-labelledby={"headingOne" + index} data-parent="#accordion">
                                    <div class="card-body">
                                      <button class="btn btn-sm btn-primary" onClick={addAPIDataRow} id={"add_api_btn|" + index}>Add API</button><br /><br />

                                      <table className="table col-md-12">
                                        <thead class="thead-light">

                                          <tr>
                                            <th>Seq No.</th>
                                            <th className="col-md-2">URL</th>
                                            <th>Method</th>
                                            <th>Body Type</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {
                                            (item.api.length > 0) ?
                                              (item.api.map((api_item, api_index) => (<>
                                                <tr>
                                                  <td rowSpan={("url_param_data" in api_item) ? 3 : 2}>{api_index + 1}</td>
                                                  <td className="col-md-3">{<textarea style={{width: '100%'}} rows={3} placeholder='Enter URL' defaultValue={api_item.api_url} id={"api_url|" + index + "|" + api_index} onChange={handleUpdateData}></textarea>}</td>
                                                  <td>{<select id={"method|" + index + "|" + api_index} defaultValue={api_item.method} onChange={handleUpdateData} onClick={handleUpdateData}><option value='POST'>POST</option><option value='GET'>GET</option><option value='PUT'>PUT</option><option value='DELETE'>DELETE</option></select>}</td>
                                                  <td>{<select defaultValue={api_item.body_type} id={"body_type|" + index + "|" + api_index} onChange={handleUpdateData} > <option value='JSON'>JSON</option><option value='formdata'>Formdata</option></select>}</td>
                                                  <td>
                                                    {<select defaultValue={api_item.enabled} id={"api_enabled|" + index + "|" + api_index} onChange={handleUpdateData}><option value={1}>Enable</option><option value={0}>Disable</option></select>}

                                                  </td>
                                                  <td><button className="btn btn-danger" onClick={addAPIDataRow} id={"delete_api_btn|" + index + "|" + api_index}>Delete</button></td>
                                                </tr>
                                                <tr>
                                                  <td colSpan={5}>
                                                    <button className="btn btn-sm" id={"add_param_btn|" + index + "|" + api_index} onClick={addParamData}>Add Params</button>
                                                    {
                                                      (api_item.data.map((api_item_data, api_item_index) => (
                                                        <>

                                                          <div className="form-row">
                                                            <div class="form-group col-md-2">
                                                              <label for="inputPassword4">Flag</label>
                                                              <select class="form-control" defaultValue={api_item_data.flag} id={"api_flag|" + index + "|" + api_index + "|" + api_item_index} onChange={handleUpdateData} onClick={handleUpdateData}>
                                                                <option value="D">Dynamic</option>
                                                                <option value="S">Static</option>
                                                              </select>
                                                              {/* <input type="text" class="form-control" defaultValue={api_item_data.flag} /> */}
                                                            </div>
                                                            <div class="form-group col-md-3">
                                                              <label for="inputPassword4">Key</label>
                                                              <input type="text" class="form-control" defaultValue={api_item_data.key} onChange={handleUpdateData} id={"api_key|" + index + "|" + api_index + "|" + api_item_index} />
                                                            </div>
                                                            <div class="form-group col-md-2">
                                                              <label for="inputPassword4">Value</label>
                                                              <input type="text" class="form-control" defaultValue={api_item_data.value} onChange={handleUpdateData} id={"api_value|" + index + "|" + api_index + "|" + api_item_index} />
                                                            </div>
                                                            <div class="form-group col-md-3">
                                                              <label for="inputPassword4">Convert Datatype</label>
                                                              <input type="text" class="form-control" defaultValue={api_item_data.con_datatype} onChange={handleUpdateData} id={"convert_dt|" + index + "|" + api_index + "|" + api_item_index} />
                                                            </div>

                                                            <div class="form-group col-md-2" style={{ margin: "auto", paddingTop: '8px' }}>
                                                              <button className="btn btn-sm btn-danger" id={"remove_param_btn|" + index + "|" + api_index + "|" + api_item_index} onClick={addParamData}>Remove</button>
                                                            </div>
                                                          </div>
                                                        </>
                                                      )))
                                                    }

                                                  </td>
                                                </tr>
                                                {
                                                  ("url_param_data" in api_item) ?
                                                    <tr>
                                                      <td colSpan={5}>
                                                        <button className="btn btn-sm" id={"add_url_param|" + index + "|" + api_index} onClick={addParamData}>Add URL Params</button>

                                                        {
                                                          (api_item.url_param_data.map((api_url_item_data, api_url_item_index) => (
                                                            <>
                                                              <div className="form-row">
                                                                <div class="form-group col-md-3">
                                                                  <label for="inputPassword4">Flag</label>
                                                                  <select class="form-control" defaultValue={api_url_item_data.flag} id={"api_url_flag|" + index + "|" + api_index + "|" + api_url_item_index} onChange={handleUpdateData} onClick={handleUpdateData}>
                                                                    <option value="D">Dynamic</option>
                                                                    <option value="S">Static</option>
                                                                  </select>

                                                                </div>
                                                                <div class="form-group col-md-3">
                                                                  <label for="inputPassword4">Value</label>
                                                                  <input type="text" class="form-control" defaultValue={api_url_item_data.value} onChange={handleUpdateData} id={"api_url_value|" + index + "|" + api_index + "|" + api_url_item_index} />
                                                                </div>

                                                                <div class="form-group col-md-2" style={{ margin: "auto", marginLeft: 0, paddingTop: '8px' }}>
                                                                  <button className="btn btn-sm btn-danger" id={"remove_url_param|" + index + "|" + api_index + "|" + api_url_item_index} onClick={addParamData}>Remove</button>
                                                                </div>
                                                              </div>
                                                            </>
                                                          )
                                                          ))}
                                                      </td>
                                                    </tr>
                                                    : ""
                                                }




                                              </>
                                              ))) : ""
                                          }


                                        </tbody>
                                      </table>




                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          : ""
                      }

                    </div>
                  </div>
                </div>
              )
              )}
          </div>
        </div>
      </div>

      {/* <button className="btn btn-primary" onClick={handleAddStage}>Add Stage</button><br/> */}




    </div>
  );
}

export default ServiceClone;
